import { Pipe, PipeTransform } from "@angular/core";

/** AppNotificationType (backend Common/Enums/RequestStatus.cs) display labels. */
@Pipe({
  name: "notificationType",
})
export class NotificationTypePipe implements PipeTransform {
  transform(value: unknown): string {
    if (value === null || value === undefined || value === "") {
      return "";
    }
    switch (Number(value)) {
      case 0:
        return "ATM error";
      case 1:
        return "Ticket created";
      case 2:
        return "Ticket assigned";
      case 3:
        return "Ticket comment";
      case 4:
        return "Ticket resolved";
      case 5:
        return "Low cash";
      case 6:
        return "Withdrawal approved";
      case 7:
        return "Withdrawal rejected";
      case 8:
        return "Withdrawal cancelled";
      case 9:
        return "Cassette stopped";
    }
    return "";
  }
}
